import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaMagnifyingGlass } from "react-icons/fa6";
import api from '../../api/manage_database/SensorReq';
import SelectSensor from '../../components/SelectSensor';
import BackButton from "../../components/BackButton";
import { toast } from 'sonner';

const SensorChoice = () => {

    const [Sensors, setSensors] = useState([]);
    const [selectedSensor, setSelectedSensor] = useState('');
    
    const navigate = useNavigate();

    const handleView = () => {
        if (selectedSensor === '') {
            toast.error('Choose available sensor!')
            return
        } else {
            navigate(`../record/${selectedSensor}`)
        }
    }

    useEffect(() => {
        const fetchSensors = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setSensors(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchSensors();
    }, []);

    return (
        <div className='sensor-choice-container'>
            <h2 className='sensor-choice-title'>Sensor</h2>
            <div className='sensor-choice-card'>
                <div className='sensor-choice-label-select-wrapper'>
                    <label
                        htmlFor='sensor-select'
                        className='bold-label'
                    >
                        Sensor:
                    </label>
                    <SelectSensor
                        Sensors={Sensors}
                        selectedSensor={selectedSensor}
                        setSelectedSensor={setSelectedSensor}
                    />
                </div>
                <button
                    className='sensor-choice-button'
                    onClick={handleView}>View &nbsp; <FaMagnifyingGlass /></button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    );
        
};

export default SensorChoice;